import { gql } from "@apollo/client";

export const GET_ATTENDEE_LIST = gql`
  query GetAttendeeList($data: GetAttendeeListInput!) {
    getAttendeeList(data: $data)
  }
`;

export const GET_ATTENDEES = gql`
  query getEventAttendees($data: EventIdentifierInput!) {
    getEventAttendees(data: $data)
  }
`;

export const GET_EVENT_VENUES = gql`
  query getEventVenues($data: GetEventInput!) {
    getEventVenues(data: $data)
  }
`;

export const GET_EVENT_SIZES = gql`
  query getEventSizes($data: GetEventInput!) {
    getEventSizes(data: $data)
  }
`;

export const GET_COUPONS_BY_COMPANY = gql`
  query GetCouponsByCompany($companyId: String!, $eventId: String) {
    getCouponsByCompany(companyId: $companyId, eventId: $eventId)
  }
`;

export const GET_TEAM_TRAINING_SCHEDULES = gql`
  query GetTeamTrainingSchedules($data: GetTeamTrainingSchedulesInput!) {
    getTeamTrainingSchedules(data: $data)
  }
`;

export const GET_SQUAD_BUILDER_SETTINGS = gql`
  query GetSquadBuilderSettings($data: GetSquadBuilderSettingsInput!) {
    getSquadBuilderSettings(data: $data)
  }
`;

export const GET_CLUB_REVIEW_LIST = gql`
  query GetClubReviewList($data: GetClubReviewListInput!) {
    getClubReviewList(data: $data)
  }
`;

export const GET_RATING_CRITERIA = gql`
  query getRatingCriteria($data: RatingCriteriaResult!) {
    getRatingCriteria(data: $data)
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserByID($userID: String!, $eventId: String) {
    getUserByID(userID: $userID, eventId: $eventId)
  }
`;
// Query to get the scanned QR preferences (QR scanned) for a specific event.
export const GET_SCANNED_EVENT_QR_PREFERENCES = gql`
  query GetScannedEventQrPreferences($eventId: ID!) {
        getScannedEventQrPreferences(eventId: $eventId) {
      first_checked
      last_checked
      avatar_checked
      company_checked
      job_title_checked
      age_checked
      member_id_checked
      location_checked
      gender_checked
      email_checked
      mobile_checked
      phone_checked
      dob_checked
      salutation_checked
      region_checked
      country_checked
      city_checked
      postcode_checked
      address_checked
      addressTwo_checked
      bio_checked
      categorisedKeywords_checked
      clusterKeywords_checked
      keywords_checked
      locale_checked
      facebook_checked
      instagram_checked
      linkedIn_checked
      twitter_checked
      weChat_checked
      weibo_checked
      qq_checked
      skype_checked
      socialLine_checked
      nationalSecurityNumber_checked
      passportNumber_checked

      # New fields
      family_members_checked
      dietary_preferences_checked
      ethnicity_checked
      citizenship_checked
      height_checked
      weight_checked
      past_injuries_checked
      allergies_checked

      # Sports Profile
      current_team_checked
      isActive_checked
      trialVideo_checked
      currentClub_checked
      otherClubs_checked
      dominant_hand_checked
      dominant_foot_checked
      walking_frequency_over_30mins_checked
      training_frequency_checked
      protective_gear_used_checked
      preferred_training_style_checked
      past_sports_injuries_checked
      preferred_positions_by_sport_checked
      preferred_positions_short_checked
      secondary_positions_by_sport_checked
      secondary_positions_short_checked
      supplements_used_checked
    }
  }
`;

// Query to get the QR preferences (QR Entry) for a specific event.
export const GET_EVENT_QR_PREFERENCES = gql`
  query GetEventQrPreferences($eventId: ID!) {
    getEventQrPreferences(eventId: $eventId) {
      first_checked
      last_checked
      avatar_checked
      company_checked
      job_title_checked
      age_checked
      member_id_checked
      location_checked
      gender_checked
      email_checked
      mobile_checked
      phone_checked
      dob_checked
      salutation_checked
      region_checked
      country_checked
      city_checked
      postcode_checked
      address_checked
      addressTwo_checked
      bio_checked
      categorisedKeywords_checked
      clusterKeywords_checked
      keywords_checked
      locale_checked
      facebook_checked
      instagram_checked
      linkedIn_checked
      twitter_checked
      weChat_checked
      weibo_checked
      qq_checked
      skype_checked
      socialLine_checked
      nationalSecurityNumber_checked
      passportNumber_checked
    }
  }
`;
export const GET_CLUSTER_PAGE_RESTRICTIONS = gql`
  query getClusterPageRestrictions($eventId: String!) {
    getClusterPageRestrictions(data: { eventId: $eventId }) {
      eventId
      linkedPages
    }
  }
`;
